<template>
	<div class='square'>
    <div class="container">
      <h2 class="h2title">{{title}}</h2>
      <p class="descript">{{des}}</p>
      <mu-row class="mt30" gutter>
        <mu-col span="4" v-for="item in list" :key="item.id">
          <mu-paper class="demo-paper" :z-depth="2">
            <!-- <mu-ripple></mu-ripple> -->
            <i class="iconfont" :class="[item.ico]"></i>
            <!-- <mu-icon :value="item.ico" color="#932120" size="60"></mu-icon> -->
            <h4>{{item.title}}</h4>
            <p class="des">{{item.des}}</p>
          </mu-paper>
        </mu-col>
      </mu-row>
    </div>
	</div>
</template>
<script>
export default {
  name: 'square',
  props: {
    title: {
      type: String,
      default: '精细化工的绿色化和可持续发展'
    },
    des: {
      type: String,
      default: '人们对新产品的需求不断增加，国家对环境保护和安全生产也越来越重视'
    },
    list: {
      type: Array,
      default: function () {
        return [{
          id: 1, 
          ico: 'icon-lvsegongdi',          
          title: '绿色',
          des: '降低产品的生产成本，提高产品的市场竞争力'
        }, {
          id: 2, 
          ico: 'icon-anquan',
          title: '安全',
          des: '国家对环境保护和安全生产也越来越重视'
        }, {
          id: 4, 
          ico: 'icon-qingjie',
          title: '清洁',
          des: '最大程度地利用原材料资源和能源，减少或完全消除副产物的生成和排放'
        }]
      }
    }
  },
  data() {
    return {
      // title: '精细化工的绿色化和可持续发展',
      // descript: '人们对新产品的需求不断增加，国家对环境保护和安全生产也越来越重视',
      // list:[{
      //   id: '1', 
      //   ico: '',
      //   title: '绿色',
      //   des: '降低产品的生产成本，提高产品的市场竞争力'
      // }, {
      //   id: '1', 
      //   ico: '',
      //   title: '安全',
      //   des: '国家对环境保护和安全生产也越来越重视'
      // }, {
      //   id: '1', 
      //   ico: '',
      //   title: '清洁',
      //   des: '最大程度地利用原材料资源和能源，减少或完全消除副产物的生成和排放'
      // }]
    }
  },
  mounted() {
  }
}
</script>

<style>
.square{
  text-align: center;
}
.des{
  font-size: 14px;
  color: #9e9e9e;
}
h4{
  font-size: 18px;
  margin: 15px auto 10px;
}
.flex-wrapper{
  margin: 0 -15px;
}
.demo-paper{
  width: 100%;
  background-color: #ffffff;
  padding: 60px 20px;
  text-align: center;
}
.demo-paper .des{
  height: 3.2em;
  overflow: hidden;
}
.flex-demo{
  flex: 1;
  margin: 0 15px;
}
.iconfont{
  font-size: 36px;
  color: #5e5e5e;
}
@media screen and ( max-width: 768px){
   .demo-paper {            
      padding: 40px 20px;
  }
}
@media screen and ( max-width: 320px) {	
    h2.h2title {      
      font-size: 20px;
  }
    .demo-paper {            
      padding: 20px 20px;
  }
}
</style>